import TruckersMap from './TruckersMap';

export default TruckersMap;
